export default "__VITE_ASSET__378ce077__"